<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Logo Grid</b-card-title>
      </b-card-header>
      <b-card-body class="pb-1">
        <b-card-text>
          <p>
            Clear space is the term for a specific amount that a logo must have on all sides, no matter where it is used. The reason for clear space is to ensure that a logo maximizes visibility and impact.<br><br>In the logo, the base element that you select is called the "x" which indicates the basis for your clear space area. To set the area of clear space around your logo, measure one "x" unit from the furthest vertical and horizontal point of your logo.
          </p>
        </b-card-text>
        <b-row
          class="match-height"
        >
          <b-col
            lg="6"
            md="6"
            sm="12"
            class="mb-2"
          >
            <div class="text-center">
              <b-img
                :src="require('@/assets/images/logo/logo-grid/ep-logomark-grid.svg')"
                class="w-75"
                alt="EasyParcel Logomark Grid"
              />
              <br>
              <small>EasyParcel Logomark</small>
            </div>
          </b-col>
          <b-col
            lg="6"
            md="6"
            sm="12"
            class="mb-2"
          >
            <div class="text-center">
              <b-img
                :src="require('@/assets/images/logo/logo-grid/eplogo-vertical-grid.svg')"
                class="w-75"
                alt="EasyParcel Vertical Logo Grid"
              />
              <br>
              <small>EasyParcel Vertical Logo</small>
            </div>
          </b-col>
          <b-col
            lg="6"
            md="6"
            sm="12"
          >
            <div class="text-center">
              <b-img
                :src="require('@/assets/images/logo/logo-grid/eplogo-horizontal-grid.svg')"
                class="w-75"
                alt="EasyParcel Horizontal Logo Grid"
              />
              <br>
              <small>EasyParcel Horizontal Logo</small>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BRow, BCol, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BImg,
  },
  directives: {
    Ripple,
  },
}
</script>
